/**
 * This function sends a POST request to the server to download a sample table. The
 * server will respond with a CSV file that will get automatically downloaded to
 * the user's system.
 */

import { apiBase } from 'functions/server/apiBase';


//json file should have locations and costs
async function download_sample_table(json) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ json })
    };
    const response = await fetch(apiBase() + '/download_sample_table', requestOptions)
    // Without this, a 4xx/5xx error body was still turned into a Blob and
    // "downloaded" as a corrupt CSV, and the caller had no way to tell success
    // from failure. Throw so the thunk rejects instead of reporting success.
    if (!response.ok) {
        throw new Error('Sample table download failed: HTTP ' + response.status);
    }
    const buffer = await response.arrayBuffer();
    const blob = new Blob([buffer], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = json.tableName + '.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export default download_sample_table
